/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL21haW4vaHIvdHJhbnNsYXRvci9idWxrLWVtYWlsLXRyYW5zbGF0b3IvYnVsay1lbWFpbC10cmFuc2xhdG9yLmNvbXBvbmVudC5zY3NzIn0= */"];
export { styles as styles };
